/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};

;// CONCATENATED MODULE: ./src/DOMUtils.js
class DOMUtils {
  /* Observes children to check if an element matches the selector */
  static onCreate(selector, rootSelector = 'body') {
    const promise = new Promise((resolve, reject) => {
      const element = document.querySelector(selector);
      const root = document.querySelector(rootSelector);

      if (!root) { reject(); }
      if (element) { resolve(); }

      const observer = new MutationObserver((mutations, self) => {
        for (const m of mutations) {
          for (const n of m.addedNodes) {
            if (n && n.matches && n.matches(selector)) {
              self.disconnect();
              resolve();
            }
          }
        }
      });

      observer.observe(root, { childList: true, subtree: true });
    });
    return promise;
  }

  static createObserver(selector, onChange) {
    const element = document.querySelector(selector);
    if (!element) { return null; }

    const observer = new MutationObserver(onChange);

    observer.observe(element, {
      childList: true,
      subtree: true,
    });

    return observer;
  }

  static addEventListener(type, selector, fn) {
    document.addEventListener(type, (event) => {
      if (event.target && event.target.closest(selector)) {
        fn();
      }
    }, false);
  }

  /* fn() is triggered if the click appears outside of the element with that selector */
  static addOnClickOutsideListener(selector, fn) {

    const listener = (event) => {
      const element = document.querySelector(selector);
      if (!element) {
        return;
      }

      const isInside = element.contains(event.target);

      // /* debug */
      // let e = event.target;
      // while (e) {
      //   console.log({ e, parent: e.parentNode });
      //   e = e.parentNode;
      // }
      // console.log('end iterating thru parents');
      // /* /debug */

      if (!isInside) {
        fn(event);
      }
    };

    document.addEventListener('click', listener);
  }
}

;// CONCATENATED MODULE: ./src/elements/Elem.js
class Selector {
  /*
  * Representation of an element in the "delivery" cart section layout.
  * Defined by a selector
  */

  constructor(selector) {
    this.selector = selector;
  }

  exists() {
    return !!(this.getDOMElement());
  }

  getDOMElement() {
    return document.querySelector(this.selector);
  }

  _changeClass(className, method) {
    const elem = this.getDOMElement();
    if (!elem) { return; }
    elem.classList[method](className);
  }

  toggleClass(className) {
    this._changeClass(className, 'toggle');
  }

  addClass(className) {
    this._changeClass(className, 'add');
  }

  removeClass(className) {
    this._changeClass(className, 'remove');
  }
}

;// CONCATENATED MODULE: ./src/elements/ActiveButton.js


class ActiveButton extends Selector {
  /*
   * Checks the classes to identify the delivery option button.
   * This corresponds to grid columns.
   */

  getOptionNo() {
    const columnMapping = {
      'store-pickup-identixweb-order-delivery-date': 1,
      'local-delivery-identixweb-order-delivery-date': 2,
      'shipping-identixweb-order-delivery-date': 3,
      'international-shipping-identixweb-order-delivery-date': 4,
    };

    let column;

    const elem = this.getDOMElement();
    if (!elem) return null;
    this.getDOMElement().classList.forEach((className) => {
      const col = columnMapping[className];
      if (col) { column = col; }
    });

    return column;
  }
}

;// CONCATENATED MODULE: ./src/DeliveryDate.js
class DeliveryDate {
  /* Wrapper class for date */
  date = null;

  /* Takes date in format DD/MM/YYYY (e.g. 21/10/2021) and returns corresponding Date object */
  constructor(str) {
    const tokens = str.split('/');
    let [days, months, years] = tokens;
    months -= 1; // JavaScript counts months from Jan = 0
    this.date = new Date(years, months, days);
  }

  isInFuture() {
    const now = Date.now();
    return this.date > now;
  }

  format() {
    // const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    // const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const days = ['Sun.', 'Mon.', 'Tue.', 'Wed.', 'Thu.', 'Fri.', 'Sat.'];
    const months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'June.', 'July.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];

    const d = this.date;
    if (!d) return '';

    return `${days[d.getDay()]}, ${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
  }

  formatJQuery() {
    const d = this.date;
    return this.format();
  }
}

;// CONCATENATED MODULE: ./src/Cart.js


class Cart {
  constructor() {
    this.attributes = {};
    this.items = [];
    this.date = null;
  }

  /* Fetches API cart data. Returns true/false depending on if cart has been initialised successfully */
  getCart() {
    const res = fetch('/cart.js')
      .then((res) => res.json());

    /* Destructuring the response */
    const promise = res.then((apiData) => {
      this.attributes = apiData.attributes;
      this.items = apiData.items;

      const dateStr = this.attributes && this.attributes['Delivery Date'];
      this.date = dateStr ? new DeliveryDate(dateStr) : null;

      return true;
    }).catch((_) => false);

    return promise;
  }

  /* Items hierarchy implemented as int scores for easy comparison */
  hierarchy = {
    'Shop The River Cafe': 2, // all Click and Collect items can also be delivered within M25
    'Available within London': 2,
    'Available across Greater London and the UK': 3,
    'Available Worldwide': 4,
  };

  /* Returns array of Bools showing which cart elements pass the current category match */
  checkDeliverables(currentCategory) {
    if (!this.items) return [];

    const toCategoryScore = ({ vendor }) => this.hierarchy[vendor] || this.hierarchy['Shop The River Cafe'];

    /* Items must score at minimum the current category value */
    const items = this.items.map((i) => {
      const score = toCategoryScore(i);
      return score >= currentCategory;
    });

    return items;
  }

  getOriginalDeliveryOption() {
    const optionLabel = (this.attributes && this.attributes['Order Type']) || null;
    return optionLabel;
  }

  updateCartAttributes(attrs) {
    const { date, day, orderType } = attrs;

    const body = JSON.stringify({
      // JSON.stringify() will remove any properties that have `undefined` value
      attributes: {
        'Delivery Date': date,
        'Delivery Day': day,
        'Order Type': orderType,
      },
    });

    const promise = fetch('', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    });

    return promise;
  }

  getDate() {
    return this.date ? this.date.format() : undefined;
  }

  verifyDate() {
    if (!this.attributes['Delivery Date']) return false;
    const cartDate = Cart.parseDate(this.attributes['Delivery Date']);
  }
}

;// CONCATENATED MODULE: ./src/index.js
// import TRCOrderDeliveryDate from './trc-odd.js';





class TRCOrderDeliveryDate {
  cart = new Cart();

  constructor() {
    /* Behaviour on plugin load */
    this.pluginLoaded = DOMUtils.onCreate(".identixweb-order-delivery-tab");
    this.pluginLoaded.then(() => {
      var me = this;
      setTimeout(function () {
        me.injectInternationalButton();
        me.addSubheadingsToButtons();
        me.removeConflictingStyleNodes();

        me.movePopdown();
        me.addDatePickerBtn();

        document
            .querySelector(".shipping-identixweb-order-delivery-date")
            .click();
        document
            .querySelector(".store-pickup-identixweb-order-delivery-date")
            .click();
      }, 1000);

    });

    DOMUtils.addEventListener(
        "click",
        ".store-pickup-identixweb-order-delivery-date",
        () => {
          const { btnInternational } = this.elements;
          let btnI = document.querySelector(
              ".international-shipping-identixweb-order-delivery-date"
          );
          if (btnI.classList.contains("active")) {
            btnInternational.removeClass("active");
            document.querySelector('input[name="checkout"]').disabled = false;
            document
                .querySelector(".local-delivery-identixweb-order-delivery-date")
                .click();
            document
                .querySelector(".store-pickup-identixweb-order-delivery-date")
                .click();
          }
        }
    );

    DOMUtils.addEventListener(
        "click",
        ".local-delivery-identixweb-order-delivery-date",
        () => {
          const { btnInternational } = this.elements;
          let btnI = document.querySelector(
              ".international-shipping-identixweb-order-delivery-date"
          );
          if (btnI.classList.contains("active")) {
            btnInternational.removeClass("active");
            document.querySelector('input[name="checkout"]').disabled = false;
            document
                .querySelector(".store-pickup-identixweb-order-delivery-date")
                .click();
            document
                .querySelector(".local-delivery-identixweb-order-delivery-date")
                .click();
          }
        }
    );

    DOMUtils.addEventListener(
        "click",
        ".shipping-identixweb-order-delivery-date",
        () => {
          document.querySelector('input[name="checkout"]').disabled = false;
          const { btnInternational } = this.elements;
          btnInternational.removeClass("active");
        }
    );

    /* Perform actions on DOM tree update  */
    this._observer = DOMUtils.createObserver(
        this.elements.pluginRoot.selector,
        (mutationList) => {
          if (this.pluginLoaded) {
            this.movePopdown();
            this.addDatePickerBtn();
            this.highlightFailingItems();
          }
        }
    );
    this.cartLoaded = this.cart.getCart();
    Promise.all([this.cartLoaded, this.pluginLoaded]).then(() => {});

    /* Add handler for UK delivery */
    DOMUtils.addEventListener("click", this.elements.btnUK.selector, () => {
      setTimeout(() => this.handleUKDetails(), 300);

      const onLoadUK = new Promise((resolve, reject) => {
        const handler = (mutationsList, observer) => {
          mutationsList.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              try {
                if (node.matches(this.elements.detailsPopdown.selector)) {
                  observer.disconnect();
                  resolve();
                }
              } catch (e) {}
            });
          });
          // observer.disconnect();
        };

        const obs = new MutationObserver(handler);
        const target = document.querySelector(
            ".cart-template__delivery-options"
        );
        obs.observe(target, { childList: true, subtree: true });
      });
    });

    /* Add handler for International delivery */
    DOMUtils.addEventListener(
        "click",
        this.elements.btnInternational.selector,
        () => {
          this.activateInternationalColumn();
        }
    );
  }

  /* Behaviour on plugin and cart load */

  /* Set of elements as used by the third-party plugin */
  elements = {
    pluginRoot: new Selector(".identixweb-order-delivery"),
    container: new Selector(".cart-template__delivery-options"),
    btnClickAndCollect: new Selector(
        ".store-pickup-identixweb-order-delivery-date"
    ),
    btnLondon: new Selector(
        ".local-delivery-identixweb-order-delivery-date"
    ),
    btnUK: new Selector(".shipping-identixweb-order-delivery-date"),
    btnInternational: new Selector(
        ".international-shipping-identixweb-order-delivery-date"
    ),
    /* Matches any of the four category buttons */
    categoryBtn: new Selector(
        `.store-pickup-identixweb-order-delivery-date,.local-delivery-identixweb-order-delivery-date,.shipping-identixweb-order-delivery-date,.international-shipping-identixweb-order-delivery-date`
    ),
    detailsPopdown: new Selector(".identixweb-order-delivery-date-main"),

    activeButton: new ActiveButton(
        ".cart-template__delivery-options .active"
    ),
    buttonContainer: new Selector(".identixweb-order-delivery-tab"),
    datePickerToggle: new Selector(".date-picker-toggle"),
    datePickerToggleText: new Selector(".date-picker-toggle-text"),
    datePickerContainer: new Selector(".uiDeliveryCalendar"),
    datePicker: new Selector(
        ".ui-datepicker"
    ) /* refers to the actual JQuery-UI component */,
  };

  htmlSnippets = {
    unavailableDelivery: `
    <p class="identixweb-order-delivery-date-deliveryRequired" style="display:block">Some products, highlighted in your basket above, cannot use this delivery option. Please remove them to continue, or choose an alternative delivery method.</p>
    `,
    internationalAvailableDelivery: `
    <p class="identixweb-order-delivery-date-deliveryAvailable" style="display:block">Please enter your address in the checkout to view delivery costs</p><input type="hidden" name="attributes[Delivery Date]" /><input type="hidden" name="attributes[Delivery Day]" /><input type="hidden" name="attributes[Order Type]" value="International Delivery" />
    `,
  };

  injectInternationalButton() {
    const container = new Selector(
        ".identixweb-order-delivery-tab"
    ).getDOMElement();
    if (!container || container.classList.contains("has-international")) {
      return;
    }

    const className =
        "international-shipping-identixweb-order-delivery-date";

    const innerHTML = `
                 <div class="international-shipping-identixweb-order-delivery-date identixweb-btn-icon identixweb-order-delivery-tablinks">
                   International
                 </div>`;

    const dummy = document.createElement("div");
    dummy.innerHTML = innerHTML;
    const button = dummy.firstElementChild;

    container.appendChild(button);
  }

  addDatePickerBtn() {
    var me = this;

    const datePickerLoaded = new Selector(
        ".date-picker-toggle"
    ).getDOMElement();
    if (datePickerLoaded) {
      return;
    }
    me.createDatePickerButton();
    me.addDatePickerListener();
  }

  createDatePickerButton() {
    var me = this;
    let datePicker = new Selector(".uiDeliveryCalendar").getDOMElement();
    if (!datePicker) {
      return;
    }

    let div = document.createElement("div");
    div.className = "date-picker-toggle";
    div.innerHTML = "Please choose a date...";
    datePicker.parentNode.insertBefore(div, datePicker);

    /** add event listeners */
    div.addEventListener("click", function () {
      document.querySelector(".uiDeliveryCalendar").style.display = "block"; // display date picker
      const dateSelectors = document.querySelectorAll(".ui-state-default");
      dateSelectors.forEach((dateSelector) => {
        dateSelector.addEventListener("click", function handleClick(event) {
          if (
              dateSelector.parentNode.classList.contains("ui-state-disabled")
          ) {
            return;
          } // do nothing if disabled date
          document.querySelector(".uiDeliveryCalendar").style.display =
              "none";
          // update btn
          me.updateDatePickerButton();
        });
      });
    });
  }

  addDatePickerListener() {
    var me = this;
    let datePicker = new Selector(".uiDeliveryCalendar").getDOMElement();
    if (!datePicker) {
      return;
    }

    datePicker.addEventListener("click", function (event) {
      // reload listener on prev and next month
      if (
          event.target.classList.contains("ui-datepicker-prev") ||
          event.target.classList.contains("ui-datepicker-next") ||
          event.target.parentNode.classList.contains("ui-datepicker-prev") ||
          event.target.parentNode.classList.contains("ui-datepicker-next")
      ) {
        const dateSelectors2 =
            document.querySelectorAll(".ui-state-default");
        dateSelectors2.forEach((dateSelector) => {
          dateSelector.addEventListener(
              "click",
              function handleClick(event) {
                if (
                    dateSelector.parentNode.classList.contains(
                        "ui-state-disabled"
                    )
                ) {
                  return;
                }
                document.querySelector(".uiDeliveryCalendar").style.display =
                    "none";
                me.updateDatePickerButton();
              }
          );
        });
      }
      // close calendar when clicking outside
      if (!event.target.classList.contains("uiDeliveryCalendar")) {
        return;
      }
      document.querySelector(".uiDeliveryCalendar").style.display = "none";
    });
  }

  updateDatePickerButton() {
    setTimeout(function () {
      let selectedDate = document.querySelector(".deliveryDateValue");
      let div = document.querySelector(".date-picker-toggle");
      div.className = "date-picker-toggle valid";
      let dd = selectedDate.value.split("/").reverse().join("-");
      const d = new Date(dd).toLocaleString("en-GB", {
        weekday: "short",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      div.innerHTML = d;
    }, 250);
  }

  /* Displays error message if UK delivery is not possible for this cart */
  handleUKDetails() {
    const UKIndex = 3;
    if (this.activeColumn != UKIndex) return;

    this.cartLoaded.then(() => {
      const deliverables = this.cart.checkDeliverables(UKIndex);
      const isTrue = (x) => x;

      /* if some product is not able to be delivered in the UK */
      if (!deliverables.every(isTrue)) {
        const details = this.elements.detailsPopdown.getDOMElement();
        details.innerHTML = "";
        details.innerHTML += this.htmlSnippets.unavailableDelivery;
      }
    });
  }

  activateInternationalColumn() {
    document
        .querySelector(".local-delivery-identixweb-order-delivery-date")
        .click();

    /* Remove contents of details container */
    let popdown = this.elements.detailsPopdown.getDOMElement();
    if (!popdown) return;
    popdown.innerHTML = "";

    /* Activate International tab */
    const { btnInternational, btnClickAndCollect, btnUK, btnLondon } =
        this.elements;
    btnInternational.addClass("active");
    btnClickAndCollect.removeClass("active");
    btnUK.removeClass("active");
    btnLondon.removeClass("active");

    /* Insert contents of details container */
    popdown = this.elements.detailsPopdown.getDOMElement();
    if (!popdown) return;
    const internationalIndex = 4;
    const deliverables = this.cart.checkDeliverables(internationalIndex);
    const isTrue = (x) => x; // identity function since array is already boolean

    if (deliverables.every(isTrue)) {
      popdown.innerHTML = this.htmlSnippets.internationalAvailableDelivery;
    } else {
      popdown.innerHTML = this.htmlSnippets.unavailableDelivery;
      document.querySelector('input[name="checkout"]').disabled = true;
    }
  }

  highlightFailingItems() {
    const activeOption = this.elements.activeButton.getOptionNo();
    const items = this.cart.checkDeliverables(activeOption);
    if (!items) return;

    const itemElements = document.querySelectorAll(".cart-template__item");

    itemElements.forEach((elem, i) => {
      if (items[i] === undefined) return;

      const className = "undeliverable";
      const cl = elem.classList;
      items[i] ? cl.remove(className) : cl.add(className);
    });
  }

  addSubheadingsToButtons() {
    function addSubHeading(el, text) {
      if (el && !el.classList.contains("has-subheading")) {
        el.insertAdjacentHTML("beforeend", `<span>${text}</span>`);
        el.classList.add("has-subheading");
      }
    }

    const tabClickAndCollect = document.querySelector(
        ".store-pickup-identixweb-order-delivery-date"
    );
    const tabLondon = document.querySelector(
        ".local-delivery-identixweb-order-delivery-date"
    );
    const tabUK = document.querySelector(
        ".shipping-identixweb-order-delivery-date"
    );
    const tabInternational = document.querySelector(
        ".international-shipping-identixweb-order-delivery-date"
    );

    addSubHeading(tabClickAndCollect, "Pick up from the River Café");
    addSubHeading(tabLondon, "Delivery to London postcodes");

    /* Rename heading from "Shipping" to "UK" */
    const heading = tabUK.querySelector(".identixweb-btn-icon");
    if (heading) {
      heading.innerHTML = "UK";
    }

    addSubHeading(
        tabUK,
        'Nationwide delivery (<a href="https://shoptherivercafe.co.uk/pages/delivery-returns" target="_blank">T&Cs</a>)'
    );
    addSubHeading(
        tabInternational,
        'International delivery (<a href="https://shoptherivercafe.co.uk/pages/delivery-returns" target="_blank">T&Cs</a>)'
    );
  }

  removeConflictingStyleNodes() {
    const styles = document.querySelectorAll("style");
    const pattern = /local-delivery-order-delivery-date/;

    styles.forEach((s) => {
      /* Remove all nodes that match pattern */
      if (pattern.test(s.innerHTML)) {
        s.remove();
      }
    });
  }

  movePopdown() {
    const popdown = this.elements.detailsPopdown.getDOMElement();

    if (!popdown) {
      return;
    }

    const optionNo = this.elements.activeButton.getOptionNo();
    const activeColumn = optionNo;
    if (activeColumn) {
      this.activeColumn = activeColumn;

      // No need to remove previous classes, this element is recreated on change of delivery option
      popdown.classList.add(`grid-column-${activeColumn}`);
      popdown.classList.add(`option-${optionNo}`);
    }
  }
}


window.addEventListener('DOMContentLoaded', (event) => {
  new TRCOrderDeliveryDate();

/* Toggle show/hide of delivery instruction boxes */
  const selectors = [
    [
      '.cart__special-checkbox__input[name="attributes[\'Notes and delivery instructions?\']"]',
      '.cart__special-textarea[name="attributes[\'Notes and delivery instructions\']"]',
    ],
    [
      '.cart__special-checkbox__input[name="attributes[\'Gift Message?\']"]',
      '.cart__special-textarea[name="attributes[\'Gift Message\']"]',
    ],
  ];

  const getElements = ((arr) => arr.map((sel) => document.querySelector(sel)));
  const elementPairs = selectors.map((selPair) => getElements(selPair));

  const handleChange = function (checkbox, input) {
    if (!checkbox || !input) return;

    const cl = input.classList;
    checkbox.checked ? cl.remove('hidden') : cl.add('hidden');
  };

  elementPairs.forEach(([checkbox, input]) => {
    handleChange(checkbox, input); // For initial state of checkboxes
    checkbox && checkbox.addEventListener('change', () => handleChange(checkbox, input));
  });
});

/******/ })()
;